import { View } from "extensions/marionette";
import { _ } from "extensions/underscore";

export const ExpandedRowView = View.extend({
    tagName: "tr",
    className: "expandedRow collapsedRow",
    template: ({ colspan }) => `<td colspan="${colspan}"><div class="expandedRowContent"></div></td>`,
    regions: {
        content: ".expandedRowContent"
    },
    serializeData() {
        return {
            colspan: this.getOption("colspan")
        };
    },
    show() {
        const self = this.render();
        window.setTimeout(() => {
            self.$el.removeClass("collapsedRow");
        }, 0);
        return this;
    },
    hide() {
        this.$el.addClass("collapsedRow");
        window.setTimeout(_.bind(this.destroy, this), 600);
        return this;
    },
    onRender() {
        const content = this.getOption("content");
        
        if (content) {
            this.showChildView("content", content);
        }
    }
});
